import styled from '@emotion/styled';

import { sharpImageRendering } from '../../styles/images';

import Image from './Grafik_family.png';
import Image2x from './Grafik_family@2x.png';
import ImageMobile from './Grafik_family_mobile.png';
import ImageMobile2x from './Grafik_family_mobile@2x.png';

const Hero = styled.div`
  ${sharpImageRendering}
  display: inline-block;
  width: 542px;
  height: 426px;
  max-width: 100%;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url(${Image});

  @media only screen and (max-width: 375px),
         only screen and (max-width: 375px),
  {
    background-image: url(${ImageMobile});
  }

  @media only screen and (max-width: 375px) and (-webkit-min-device-pixel-ratio: 1.5),
         only screen and (max-width: 375px) and (min-resolution: 144dpi),
  {
    background-image: url(${ImageMobile2x});
  }

  @media only screen and (min-width: 376px) and (-webkit-min-device-pixel-ratio: 1.5),
         only screen and (min-width: 376px) and (min-resolution: 144dpi),
  {
    background-image: url(${Image2x});
  }
`;

export default Hero;



// WEBPACK FOOTER //
// ./src/components/PageHeader/Hero/Hero.js